"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const schedule_controller_1 = require("@/controllers/schedule-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const clipboard_1 = require("@/utils/clipboard");
// 복사됨 표시를 유지하는 시간(ms).
const COPIED_DURATION = 1500;
/**
 * 텍스트를 클립보드에 복사하는 버튼.
 * 복사 성공 시 일시적으로 체크 아이콘으로 전환됩니다.
 */
let CopyButton = class CopyButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.tooltipPlacement = 'bottom-start';
        this.copied = false;
        this.copiedReset = new schedule_controller_1.ScheduleController(this, () => {
            this.copied = false;
        }, { delay: COPIED_DURATION });
        this.handleClick = async () => {
            const text = this.value || this.textContent?.trim() || '';
            if (!(await (0, clipboard_1.copyToClipboard)(text)))
                return;
            (0, utils_1.emit)(this, 'copy', { value: text });
            this.copied = true;
            this.copiedReset.request();
        };
    }
    render() {
        return (0, icon_button_utils_1.renderIconAction)({
            icon: this.copied ? icon_names_1.ICON_NAMES.COPY_SUCCESS : icon_names_1.ICON_NAMES.COPY,
            ariaLabel: this.copied ? '복사됨' : '복사',
            tooltipPlacement: this.tooltipPlacement,
            onClick: this.handleClick,
        });
    }
};
CopyButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    (0, lit_1.css) `
      :host {
        ${(0, icon_button_styles_1.iconButtonVariantSkin)('ghost')}
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CopyButton.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'tooltip-placement' })
], CopyButton.prototype, "tooltipPlacement", void 0);
__decorate([
    (0, decorators_js_1.state)()
], CopyButton.prototype, "copied", void 0);
CopyButton = __decorate([
    (0, decorators_js_1.customElement)('mm-copy-button')
], CopyButton);
exports.CopyButton = CopyButton;
//# sourceMappingURL=data:application/json;base64,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